<div class="ap-charges-container">
  <div
    class="table-tabs-container"
    appTabIconClickShortcut
    appApArChargeGridAddShortcut>
    <div class="table-tabs-header">
      <div class="table-tabs-title ibc-heading-h7-bold-subtitle">
        <span class="table-tab-name">AP Charge(s)</span>
      </div>
      <div class="tab-icons">
        <div class="">
          <app-svg-icon
            [list]="apChargesHeaderIcons"
            class="icon-section"
            (iconClicked)="onAPChargesIconClicked($event)"></app-svg-icon>
        </div>
      </div>
    </div>
    <app-add-inline-edit-table
      class="ap-charges-table"
      [inlineCrudTableCustomizeConfig]="tableColumnConfig"
      [formConfig]="apChargesFormConfig"
      [pageMode]="pageMode"
      [isFrom]="tableName.apChargesForShipmentAndMawb"
      [isEditIconClicked]="isEditClicked"
      [displayedColumnsOverride]="displayedColumnsOverride"
      [externalAutocompleteKeys]="invoiceAutocompleteKeys"
      [externalDropdownData]="invoiceDropdownData"
      (inlineCrudTableFormValue)="onAPChargesGridFormFieldChange($event)"
      (inlineTableSelectionChange)="onAPChargesTableSelectionChange($event)"
      (appendChargeRowFromKeyboard)="onAppendChargeRowFromKeyboard($event)">
    </app-add-inline-edit-table>

    <!-- Total Row Section -->
    <div *ngIf="showTotalRow" class="ap-charges-total-row">
      <div class="total-row-container">
        <div class="total-label">
          <span class="">Total Charge Amount : </span>
        </div>
        <div class="total-amount">
          <span class="">$ {{ totalChargeAmount | number: '1.2-2' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
